var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuildStrongProcess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 63.613 59.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15725",
    "data-name": "Group 15725",
    transform: "translate(0.505 -12.844)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28201",
    "data-name": "Path 28201",
    d: "M59.523,261.519a3.729,3.729,0,0,0-2.882.55l-10.655,7.321a4.11,4.11,0,0,0-1.735-1.247l-17.1-6.467a19.171,19.171,0,0,0-6.8-1.243H19.262a19.223,19.223,0,0,0-4.614.563l-13.7,3.39a1.251,1.251,0,0,0-.907,1.539L3.3,277.994a1.244,1.244,0,0,0,1.348.915l11.1-1.268,14.813,6.143a9.219,9.219,0,0,0,6.934.063l11.515-4.526a1.249,1.249,0,0,0,.4-.253l11.881-11.156a3.748,3.748,0,0,0-1.77-6.394Zm.06,4.573L47.876,277.084l-11.291,4.438a6.727,6.727,0,0,1-5.064-.046L16.409,275.21a1.239,1.239,0,0,0-.478-.1,1.076,1.076,0,0,0-.142.009L5.438,276.306l-2.649-9.8,12.46-3.083a16.734,16.734,0,0,1,4.013-.489h1.081a16.668,16.668,0,0,1,5.921,1.082l17.1,6.466a1.621,1.621,0,0,1,.912.864q.024.055.044.11a1.338,1.338,0,0,0,.057.2,1.622,1.622,0,0,1-1.917,1.936l-13.715-2.855a1.25,1.25,0,1,0-.51,2.448l13.716,2.855a4.128,4.128,0,0,0,4.959-4.252l11.127-7.645a1.247,1.247,0,0,1,1.747.379A1.251,1.251,0,0,1,59.582,266.093Z",
    transform: "translate(0 -212.419)",
    fill: "#96006b",
    stroke: "#96006b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28202",
    "data-name": "Path 28202",
    d: "M179.176,13.344H138.451a1.249,1.249,0,0,0-1.249,1.249V43.748A1.249,1.249,0,0,0,138.451,45h40.725a1.249,1.249,0,0,0,1.249-1.249V14.593A1.249,1.249,0,0,0,179.176,13.344Zm-39.475,2.5h38.226V27.922H139.7ZM177.927,42.5H139.7V30.421h38.226V42.5Z",
    transform: "translate(-117.951)",
    fill: "#ff0185",
    stroke: "#ff0185",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28203",
    "data-name": "Path 28203",
    d: "M178.611,52.677a1.249,1.249,0,0,0-1.249,1.249v3.54a1.249,1.249,0,0,0,2.5,0v-3.54A1.249,1.249,0,0,0,178.611,52.677Z",
    transform: "translate(-152.476 -33.814)",
    fill: "#ff0185",
    stroke: "#ff0185",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28204",
    "data-name": "Path 28204",
    d: "M214.423,52.677a1.249,1.249,0,0,0-1.25,1.249v3.54a1.249,1.249,0,0,0,2.5,0v-3.54A1.249,1.249,0,0,0,214.423,52.677Z",
    transform: "translate(-183.263 -33.814)",
    fill: "#ff0185",
    stroke: "#ff0185",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28205",
    "data-name": "Path 28205",
    d: "M286.537,64.549H269.889a1.249,1.249,0,1,0,0,2.5h16.649a1.249,1.249,0,1,0,0-2.5Z",
    transform: "translate(-230.946 -44.02)",
    fill: "#ff0185",
    stroke: "#ff0185",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28206",
    "data-name": "Path 28206",
    d: "M178.611,162.605a1.249,1.249,0,0,0,1.25-1.249v-3.541a1.249,1.249,0,0,0-2.5,0v3.541A1.249,1.249,0,0,0,178.611,162.605Z",
    transform: "translate(-152.476 -123.125)",
    fill: "#ff0185",
    stroke: "#ff0185",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28207",
    "data-name": "Path 28207",
    d: "M214.423,162.605a1.249,1.249,0,0,0,1.249-1.249v-3.541a1.249,1.249,0,0,0-2.5,0v3.541A1.249,1.249,0,0,0,214.423,162.605Z",
    transform: "translate(-183.263 -123.125)",
    fill: "#ff0185",
    stroke: "#ff0185",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28208",
    "data-name": "Path 28208",
    d: "M269.889,172.422h16.649a1.249,1.249,0,0,0,0-2.5H269.889a1.249,1.249,0,1,0,0,2.5Z",
    transform: "translate(-230.946 -134.609)",
    fill: "#ff0185",
    stroke: "#ff0185",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildStrongProcess);
export default __webpack_public_path__ + "static/media/BuildStrongProcess.1ecacdf9d4c9418b809c32afc067bb63.svg";
export { ForwardRef as ReactComponent };